import { render, staticRenderFns } from "./blankHome.vue?vue&type=template&id=58bf395d&"
import script from "./blankHome.vue?vue&type=script&lang=js&"
export * from "./blankHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports